import React from 'react';
import './progress-bar.scss';

export type ProgressBarProps = {
  percent: number,
  // 分子
  // numerator: number,
  // 分母
  // denominator: number,
  // 進捗カラー
  progressColor?: string,
  // 縁の色
  edgeColor?: string,
  className?: string,
  label?: string,
};

export const ProgressBar = (props: ProgressBarProps) => {
  const { progressColor = '#999999', edgeColor = '#f2f2f2', className, percent } = props;
  return (
    <div
      className={`progressBar${className ? ` ${className}` : ''}`}
      style={{ backgroundColor: edgeColor }}
    >
      <div
        className="progressBar__progress"
        style={{
          // width: `${numerator / denominator * 100}%`,
          width: `${percent}%`,
          backgroundColor: progressColor,
        }}
      />
      {props.label ? (
        <div className="progressBar__label">
          {props.label}
        </div>
      ) : (<></>)}
    </div>
  );
};